// import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
// import "react-pdf/dist/esm/Page/TextLayer.css";
// import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { useEffect, useState } from "react";
import { httpConfig } from "./httpConfig";
import { useNavigate, useParams } from "react-router-dom";

const Viewpdfpage = () => {
  const { id, grp, sheet, workId } = useParams();
  const navigat = useNavigate();
  const http = httpConfig();

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    document.getElementById("thisPDF").style.visibility = "visible";
    document.getElementById("thisLoad").style.display = "none";
    setNumPages(numPages);
    setPageNumber(1);
  }

  return (
    <div className="content-viewer-pdf-page">
      {/* <div className="nav-viewer-pdf-page">
        <span>PDF</span>
        <i
          className="bi-arrow-left"
          onClick={() => {
            navigat(`/assessment/${id}/${grp}/${sheet}/${workId}`);
          }}
        ></i>
      </div>
      <center>
        <div
          className="box-pdf-viewer"
          id="thisPDF"
          style={{ visibility: "hidden" }}
        >
          <Document
            // file={`/datasoft.co.th/estimate/image/2023/24/24_15_06_20.pdf`}
            file={`${http}/viewfiles/LineDisplay.pdf`}
            // file={`http://11.0.0.1/estimate/image/2023/8/2.pdf`}
            onLoadSuccess={onDocumentLoadSuccess}
          >
            {Array.from(new Array(numPages), (el, index) => (
              <Page key={`page_${index + 1}`} pageNumber={index + 1} />
            ))}
          </Document>
        </div>
      </center>
      <div className="loading-box" id="thisLoad">
        <div className="just-loading-page">
          <div className="loader"></div>
          <span>{`Loading...`}</span>
        </div>
      </div> */}
    </div>
  );
};
export default Viewpdfpage;
